import * as React from 'react'
import { RouteComponentProps, RouteProps, withRouter } from 'react-router'
import { Route } from 'react-router-dom'

import {
  hasPermission,
  isAuthenticated,
} from '../../core/services/auth.service'
import { NotAllowed } from '../NotAllowed'
import { NotAuthorized } from '../NotAuthorized'

interface Props extends RouteProps {
  authorizedRoles: string[]
}

const PrivateRoute: React.SFC<Props & RouteComponentProps<any>> = ({
  authorizedRoles,
  ...props
}) => {
  if (!isAuthenticated()) {
    return <Route component={NotAuthorized} />
  }

  if (!hasPermission(authorizedRoles)) {
    return <Route component={NotAllowed} />
  }

  return <Route {...props} />
}

export default withRouter(PrivateRoute)
